import * as envSettings from '@/../env/prd.json';

const apiEndpoint = envSettings.apiEndpoint;
const buildNumber = '1.10.198';
const gAnalyticsID = envSettings.gAnalyticsID;
const production = envSettings.production
const env: 'DEV' | 'HML' | 'TRAIN' | 'PRD' | 'LOCAL' = 'PRD';
const firebaseConfig = envSettings.firebase.sdk.config;

export { apiEndpoint, buildNumber, env, firebaseConfig, gAnalyticsID, production };

